export default "application/vnd.oasis.opendocument.text";